/**
 * Development environment configuration
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.dev.cuanone.com/api',
  apiBaseUrl: 'https://api.dev.cuanone.com',
  appName: 'Marina Customer Portal (Dev)',
  appVersion: '1.0.0-dev',
  enableDebug: true,
  enableLogging: true,
  logLevel: 'debug',
  features: {
    enableNotifications: true,
    enablePayments: true,
    enableDocuments: true,
  },
  storage: {
    tokenKey: 'marina_customer_token',
    refreshTokenKey: 'marina_customer_refresh_token',
    userKey: 'marina_customer_user',
  },
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: [5, 10, 25, 50],
  },
  dateFormat: 'MM/DD/YYYY',
  currency: 'USD',
  locale: 'en-US',
};
